module.exports = require("npm:swagger-methods@1.0.0/lib/index.js");